// extracted by mini-css-extract-plugin
module.exports = {"authorized":"ContactStatusTag_authorized__3gFge","blocked":"ContactStatusTag_blocked__xTDRA"};